import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

import {
  getRegPath,
  PATIENT_LANDING_DATA,
  PHYSICIAN_LANDING_DATA,
} from "../../../constants";

import Button from "../../../components/formElements/button/Button";
import { getRole } from "../../../utils/localStorage";
import SpinnerBorder from "../../../components/uiElements/loadingSpinner/SpinnerBorder";

const StepThree = ({ match, history }) => {
  const stepNum = parseInt(match.params.step);

  const LANDING_DATA =
    getRole() === "PATIENT" ? PATIENT_LANDING_DATA : PHYSICIAN_LANDING_DATA;

  return (
    <div className="container text-center" style={{ maxWidth: 800 }}>
      <Link
        className="link float-right position-absolute"
        style={{
          marginLeft: 560,
          color: "#42a8e3",
          textDecorationLine: "underline",
        }}
        to={getRegPath("/signin")}
      >
        Skip
      </Link>
      <img
        src={LANDING_DATA[stepNum - 1].image}
        alt=""
        width={458}
        height={296}
        style={{
          objectFit: "contain",
        }}
        onLoad={() => <SpinnerBorder />}
      />
      <div className="mt-n3 mb-5">
        {stepNum !== 1 && (
          <Button
            type="outline"
            indicatorButton
            className="float-left mt-n5"
            label={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-left"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                />
              </svg>
            }
            onClick={() => history.push(getRegPath("/step3/" + (stepNum - 1)))}
          />
        )}
        <Button
          type="outline"
          indicatorButton
          className="float-right mt-n5"
          label={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-right"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
              />
            </svg>
          }
          onClick={() =>
            history.push(
              stepNum !== LANDING_DATA.length
                ? getRegPath("/step3/" + (stepNum + 1))
                : getRegPath("/signin")
            )
          }
        />
      </div>
      <div
        className="mb-3"
        style={{
          minHeight: 100,
        }}
      >
        <h5 className="header ">{LANDING_DATA[stepNum - 1].title}</h5>
        <p className="w-75 text-center mx-auto">
          {LANDING_DATA[stepNum - 1].description}
        </p>
      </div>
    </div>
  );
};

export default withRouter(StepThree);
